<template>
  <Page title="Daftar Penerimaan">
    <template v-slot:toolbar>
      <v-icon @click="doPrint++">mdi-microsoft-excel</v-icon>
    </template>
    <Grid
      :datagrid.sync="datagrid"
      dbref="DOC.RptPenerimaan"
      :disabled="true"
      height="calc(100vh - 100px)"
      :doPrint="doPrint"
      :columns="[
        { name: 'No.', value: 'RowNum', width: '10px' },
        { name: 'No SPM', value: 'NoSPM', width: '320px' },
        { name: 'Tanggal SPM', value: 'TglSPM', width: '100px' },
        { name: 'Jenis SPM', value: 'NamaSPM', width: '100px' },
        { name: 'Nilai', value: 'NilaiSPM', width: '100px', class: 'right' },
        { name: 'Uraian', value: 'Keterangan', width: '300px' },
        { name: 'Penerima', value: 'Penerima', width: '100px' },
        { name: 'Tgl Diterima', value: 'TglPenerimaan', width: '100px' },
      ]"
    >
      <template v-slot:row-NoSPM="{ row }">
        <div style="width:320px;">
          <v-btn text small color="primary" @click="OpenDetail(row)">
            {{ row.NoSPM }}
          </v-btn>
        </div>
      </template>
    </Grid>
  </Page>
</template>
<script>
export default {
  data: () => ({
    datagrid: [],
    doPrint: 0,
  }),
  methods: {
    OpenDetail(row) {
      this.$router.push('/Main/Dinas/Penerimaan/' + row.PenerimaanID)
    },
  },
}
</script>
